import { bindable, computedFrom } from 'aurelia-framework';

class ProductGenericDetail {
  @bindable loading = false;
  @bindable detail = [];
  @bindable whenEmpty = 'There are no details for this product';
  @bindable links = [];
  @bindable images = [];
  @computedFrom('loading', 'detail')
  get displayOptions() {
    const hasDetails = this.detail && this.detail.length > 0;
    return {
      loading: this.loading,
      detail: hasDetails && !this.loading,
      empty: !hasDetails && !this.loading,
    };
  }
}

export { ProductGenericDetail };
